export const onKeyDownAction = (key) => {
  return (dispatch) => {
    if (key.match(/Up|Down|Left|Right|Home|End|PageUp|PageDown/)) {
      switch (key) {
        case 'Right': {
          dispatch({ type: 'KEY_RIGHT', payload: '' })
          break
        }
        case 'Left': {
          dispatch({ type: 'KEY_LEFT', payload: '' })
          break
        }
        case 'Up': {
          dispatch({ type: 'KEY_UP', payload: '' })
          break
        }
        case 'Down': {
          dispatch({ type: 'KEY_DOWN', payload: '' })
          break
        }
        default:
          break;
      }
    }
    return null
  }
}

export const calendarUpdateWithAPIAction = (firstAvailableDate, lastAvailableDate, availableDates) => ({
  type: 'CALENDAR_UPDATE_WITH_API',
  payload: {
    firstAvailableDate,
    lastAvailableDate,
    availableDates,
  },
})

export const calendarUpdateAction = (data) => ({
  type: 'CALENDAR_UPDATES',
  payload: data,
})

export const selectCalendarDateAction = (data) => ({
  type: 'SELECT_DATE',
  payload: data,
})

export const focusDayAction = (focused) => ({
  type: 'FOCUS_DAY',
  payload: {
    focused,
  },
})

export const selectPreviousAction = () => ({
  type: 'SELECT_PREVIOUS',
})

export const selectNextAction = () => ({
  type: 'SELECT_NEXT',
})
